export interface IApplications {
  id?: number
  uuid?: string
  title: string
  url: string
  description: string
  order?: number
  projects?:[
    {
      id: number
      value?: number
    }
  ]
  path?: File
}

export const applicationsInitValues: IApplications = {
  //id: 0,
  title: '',
  url: '',
  description: '',
}
